import { Button, Divider, Input, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
///redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate } from "react-router-dom";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const LateralCephaloMainPage = (props) => {
  let navigate = useNavigate();
  const [searchTxt, setSearchTxt] = useState("");
  const [_paging, setPaging] = useState({ pageNumber: 1, pageSize: 10 });
  const [_pagingAnalyses, setPagingAnalyses] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  let ListAnalyses =
    props.coreData[Url.lateral_GetListAnalyses]?.[Url.action]?.data
      ?.listAnalyses;
  let LoadingListAnalyses =
    props.coreData[Url.lateral_GetListAnalyses]?.[Url.action]?.isFetching;
  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.id}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "lateral cephalometric ",
      dataIndex: "lateral cephalometric",
      key: "lateral cephalometric",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "laterall");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateral cephalometric"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        if (item?.hasLateralCephaloAnalyse) {
          return <Tag color="#87d068">Analyses Done</Tag>;
        }
        return (
          <Button onClick={() => _onClickAnalyses(item.id)}>Analyses</Button>
        );
      },
    },
  ];

  const ColumnsAnalyses = [
    {
      title: "Patient Id",
      dataIndex: "PatientID",
      key: "PatientId",
      render: (object, item) => {
        return <div>{item.patientId}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImage?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "lateral cephalometric ",
      dataIndex: "lateral cephalometric",
      key: "lateral cephalometric",
      render: (obj, item, index) => {
        let imageObj = item?.patientImage?.find((o) => o.type == "laterall");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateral cephalometric"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <Button onClick={() => _onClickEditAnalyses(item)}>Edit</Button>;
      },
    },
  ];
  const _getListPatient = async (paging) => {
    return;
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.getPatienListForLateralCephalo;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _getListAnalysis = async () => {
    let url = Url.lateral_GetListAnalyses;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    if (!(ListAnalyses?.length > 0)) {
      _getListAnalysis();
    }

    let pagingAnalyse = JSON.parse(
      localStorage.getItem("@lateralCephaloPagingAnalyses")
    );
    if (pagingAnalyse == null) {
      pagingAnalyse = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPagingAnalyses(pagingAnalyse);

    let paging = JSON.parse(localStorage.getItem("@lateralCephaloPaging"));
    if (paging == null) {
      paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPaging(paging);
    _getListPatient(paging);
  }, []);

  const _onClickAnalyses = (id) => {
    navigate(`/lateralchephalo/analyses/${id}`);
  };
  const _onClickEditAnalyses = (item) => {
    navigate(`/lateralchephalo/analyses/${item.patientId}/${item.id}`);
  };
  const _onChangePageSize = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@lateralCephaloPaging",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPaging({ pageNumber, pageSize });
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };

  const _onChangePageSizeAnalyses = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@lateralCephaloPagingAnalyses",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPagingAnalyses({ pageNumber, pageSize });
  };

  ListAnalyses = ListAnalyses?.filter((o) => {
    let patinetImage = o.patientImage;
    patinetImage = patinetImage[0];
    let imageUrl = patinetImage.imageUrl;
    let imageName = imageUrl.split("/")[1];
    let finlaimageName =
      imageName.split("_")[0] + "_" + imageName.split("_")[1] + "_";
    return imageName.toLowerCase().includes(searchTxt);
  });

  return (
    <div>
      <div>
        <Divider>لیست آنالیزهای شما</Divider>
        <div className="flex-row ">
          <Input
            style={{ width: 100, marginLeft: 30 }}
            onChange={(e) => setSearchTxt(e.target.value)}
          />
          <Button>Search</Button>
          {searchTxt}
        </div>
        <Table
          columns={ColumnsAnalyses}
          dataSource={ListAnalyses}
          pagination={{
            current: _pagingAnalyses.pageNumber,
            pageSize: _pagingAnalyses.pageSize,

            onChange: _onChangePageSizeAnalyses,
          }}
          loading={LoadingListAnalyses}
        />
      </div>
      <Table
        columns={Columns}
        dataSource={
          props.coreData[Url.getPatienListForLateralCephalo]?.[Url.action]?.data
            ?.patients
        }
        loading={
          props.coreData[Url.getPatienListForLateralCephalo]?.[Url.action]
            ?.isFetching
        }
        pagination={{
          current: _paging.pageNumber,
          pageSize: _paging.pageSize,
          total:
            props.coreData[Url.getPatienListForLateralCephalo]?.[Url.action]
              ?.data?.totalCount,
          onChange: _onChangePageSize,
        }}
        rowKey={(o) => o.id}
      />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LateralCephaloMainPage);
